app.Home = (
    function () {
        var home = {
            // All pages - used for initializing
            Footer: function () {
                $("#btnSubmitFeedback").click(function (e) {
                    // prevent default form submit
                    e.preventDefault();

                    $("#divFeedbackLoadingIcon").show();

                    // get other data from browser
                    $("#hdnFeedbackUserAgent").val(window.navigator.userAgent);

                    const windowInnerWidth = window.innerWidth;
                    const windowInnerHeight = window.innerHeight;
                    $("#hdnFeedbackScreenSize").val(windowInnerWidth + " x " + windowInnerHeight);

                    $("#hdnFeedbackUrl").val(window.location.href);

                    var context = $(this);

                    // submit form
                    const url = "/Home/SubmitFeedback";
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: $(this).closest("form").serialize(),
                        success: function (data) {
                            if (data.success) {
                                // hide loading gif
                                $("#divFeedbackLoadingIcon").hide();
                                // clear form fields
                                $("#frmFeedback").find("input[type=text], textarea").val("");
                                $("#cbxFeedbackIsBug").prop("checked", false);
                                //$("[data-role='feedback-form']").html(data.view);
                                //$("#uploader").reset();
                                $("#uploader").empty();
                                app.fileUploaders.Init(context.closest("form"));
                                $("#divFeedback").modal("hide");
                                // show success message
                                toastr.success("Feedback successfully sent. Thank you!");
                            } else {
                                $("#divFeedbackLoadingIcon").hide();
                                toastr.error("There was an error while submitting your feedback: " + data.responseText);
                            }
                        },
                        error: function (data) {
                            $("#divFeedbackLoadingIcon").hide();
                            toastr.error("There was an error sending your feedback. Please try again.");
                        }
                    });

                    // TODO: maybe implement this someday - apetz2
                    // I had a lot of issues rendering pages that were a little more complex
                    // not worth the time at the moment, but might be neat to finish up another time

                    //const file = $("#uplScreenshot").prop("files")[0];

                    //var screenshot;
                    //getImageData(file);

                    //function getImageData(inputFile) {
                    //    if (inputFile) {
                    //        var reader = new FileReader();
                    //        reader.readAsDataURL(inputFile);
                    //        reader.onload = function (evt) {
                    //            screenshot = evt.target.result;
                    //        }
                    //        reader.onerror = function (evt) {
                    //            $("#divFeedbackLoadingIcon").hide();
                    //            toastr.error("There was an error reading your screenshot. Please try again.");
                    //            return null;
                    //        }
                    //    }
                    //}

                    //util.console.log(screenshot);

                    //html2canvas(document.body, {
                    //    ignoreElements: function (element) {
                    //        // remove all elements with a loading icon from the screenshot
                    //        if (element.classList.contains("feedback-form-loading-icon") ||
                    //            element.classList.contains("loading") ||
                    //            element.classList.contains("component-loading") ||
                    //            element.classList.contains("autocomplete-ajax-loading") ||
                    //            element.classList.contains("vis-loading") ||
                    //            element.classList.contains("accordion") ||
                    //            element.classList.contains("reveal-overlay")) {
                    //            return true;
                    //        }
                    //    }
                    //}).then(function (canvas) {
                    //    var screenshot = canvas.toDataURL();
                    //    screenshot = screenshot.replace("data:image/png;base64,", "");
                    //});
                });
            }
        };

        return home;
    }()
);